module.exports = __webpack_public_path__ + "img/icon-bookmark-reguler.2f3c33b9.png";